import { Container } from 'aurelia-framework';
import { DialogService } from 'aurelia-dialog';
import { UniversalEntitySelect } from '../../../../../dialog/universal-entity-select';
import { blockCategories } from '../../categories';

const dialogService = Container.instance.get(DialogService);

function getMediaSrc(item) {
    if (!item?.file) return '';
    return item.file.previewUrl
        ? item.file.previewUrl.replace('$width', '1500').replace('$height', '-')
        : item.file.downloadUrl || '';
}

export const img_src_default =
    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImZpbGw6IHJnYmEoMCwwLDAsMC4xNSk7IHRyYW5zZm9ybTogc2NhbGUoMC43NSkiPgogICAgICAgIDxwYXRoIGQ9Ik04LjUgMTMuNWwyLjUgMyAzLjUtNC41IDQuNSA2SDVtMTYgMVY1YTIgMiAwIDAgMC0yLTJINWMtMS4xIDAtMiAuOS0yIDJ2MTRjMCAxLjEuOSAyIDIgMmgxNGMxLjEgMCAyLS45IDItMnoiPjwvcGF0aD4KICAgICAgPC9zdmc+';

export const imageTraits = [
    {
        type: 'media-library-select',
        label: false,
    },
    {
        type: 'text',
        label: 'Source (URL)',
        name: 'src',
    },
    {
        type: 'text',
        label: 'title',
        name: 'title',
    },
    {
        type: 'text',
        label: 'Alternate text',
        name: 'alt',
    },
    {
        type: 'focal-point',
        label: false,
        name: 'focal-point',
        property: 'object-position',
    },
    {
        type: 'size-with-unit',
        label: false,
        name: 'width',
        property: 'width',
        displayLabel: 'Breite',
    },
    {
        type: 'size-with-unit',
        label: false,
        name: 'height',
        property: 'height',
        displayLabel: 'Höhe',
    },
    {
        type: 'checkbox',
        label: 'Priorität laden',
        name: 'priorityLoad',
        changeProp: 1,
    },
    {
        type: 'responsive-sizes',
        label: false,
        name: 'responsiveSizes',
    },
];

export default (editor) => {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    blockManager.add('bs-image', {
        label: 'Bild',
        category: blockCategories.basic,
        content: {
            type: 'bs-image',
        },
        media: `<svg fill="currentColor" aria-hidden="true"  focusable="false" data-prefix="fas" data-icon="image" class="svg-inline--fa fa-image fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"></path></svg>`,
    });

    const imageType = domComponents.getType('image');
    const model = imageType.model;
    const view = imageType.view;
    const type = 'bs-image';

    domComponents.addType(type, {
        extend: 'image',
        model: {
            defaults: Object.assign({}, model.prototype.defaults, {
                'custom-name': 'Image',
                tagName: 'img',
                resizable: 1,
                attributes: {
                    src: img_src_default,
                },
                classes: ['sio-image', 'max-w-full', 'h-full'],
                traits: imageTraits.concat(model.prototype.defaults.traits),
            }),
        },
        isComponent: function (el) {
            if (el && el.tagName === 'IMG' && el.classList &&
                el.classList.contains('sio-image')) {
                return { type: type };
            }
        },
        view: Object.assign({}, view, {
            events: Object.assign({}, view.events || {}, {
                dblclick: 'openMediaLibrary',
            }),
            onRender() {
                const src = this.model.get('attributes')?.src;
                if (!src || src === img_src_default) {
                    this.openMediaLibrary();
                }
            },
            openMediaLibrary(e) {
                e?.stopPropagation?.();
                dialogService
                    .open({
                        viewModel: UniversalEntitySelect,
                        model: {
                            selectModelId: 'media-database/media-item',
                            conditions: { type: { $in: ['image'] } },
                            multiSelect: false,
                        },
                    })
                    .whenClosed((data) => {
                        const items = data.output;
                        if (!items || items.length === 0) return;

                        const item = items[0];
                        const src = getMediaSrc(item);
                        if (!src) return;

                        this.model.set('src', src);
                        this.model.addAttributes({
                            alt: item?.alt ?? '',
                            title: item?.title ?? '',
                        });
                        this.model.trigger('change:attributes');
                        this.model.removeClass('gjs-plh-image');
                    });
            },
        }),
    });
};
